export default{
	namespaced: true ,
	state: {
		gutter: 30,
		order_id: '',//订单号
		activeFlag: 'online',//活动标识 线上online 线下offline
		iccid: '',
	},
	getters: {
		
	},
	mutations: {
		setGutter (state, val) {
			state.gutter = val
		},
		setOrderId (state, val) {
			state.order_id = val
		},
		setActiveFlag (state, val) {
			state.activeFlag = val
		},
		setIccid (state, val) {
			state.iccid = val
		},
	},
	actions: {
		
	}
}


// WEBPACK FOOTER //
// ./src/store/modules/parameter.js